import React from 'react';
import Section from './Section';

function Form({ step: { sections = [] } = {} }, ref) {
  return (
    <div>
      {sections.map((section, index) => {
        return <Section {...section} key={index} isLast={index === sections.length - 1} />;
      })}
    </div>
  );
}

export default React.forwardRef(Form);
